import { lazyComponent } from "common/lazy-loading";

export const LazyAccountSettings = lazyComponent(() =>
  import(/* webpackChunkName: "x-account-settings" */ "./controller").then(
    (m) => ({ default: m.AccountSettingsController }),
  ),
);
